import {
  Box,
  Center,
  LinkBox,
  LinkOverlay,
  Spacer,
  useMultiStyleConfig,
} from '@chakra-ui/react';
import React from 'react';

import { isExternalLink } from '../../../utils/link.utils';
import Button from '../../Button';
import ImageHandler from '../../ImageHandler';
import Link from '../../Link';
import { H3, ImageCaption } from '../../Text';

interface AvatarCardProps {
  image?: StaticImageDef | React.ReactElement;
  imageCaption?: string;
  icon?: React.ReactElement;
  title?: string;
  action?: {
    label: string;
    href: string;
  };
}

const AvatarCard: React.FC<AvatarCardProps> = ({
  image,
  imageCaption,
  icon,
  title,
  action,
  children,
}) => {
  const Styles = useMultiStyleConfig('AvatarCard', {});
  return (
    <LinkBox as={Center} sx={Styles.card}>
      {image ? <ImageHandler image={image} /> : icon}
      {imageCaption && <ImageCaption>{imageCaption}</ImageCaption>}
      {(title || React.Children.count(children) > 0) && (
        <Box sx={Styles.content}>
          {title && <H3 sx={Styles.title}>{title}</H3>}

          {children}
        </Box>
      )}

      <Spacer />

      {action?.href &&
        (action.label ? (
          <LinkOverlay
            as={Button}
            href={action.href}
            variant="outline"
            colorScheme="blue"
            sx={Styles.action}
            isExternal={isExternalLink(action.href)}
          >
            {action.label}
          </LinkOverlay>
        ) : (
          <LinkOverlay
            as={Link}
            to={action.href}
            variant="plain"
            isExternal={isExternalLink(action.href)}
          />
        ))}
    </LinkBox>
  );
};

export default AvatarCard;
